import React from "react";
import styled from 'styled-components';
import { graphql, useStaticQuery } from "gatsby";
import RelatedPostItem from "../parts/RelatedPostItem";

type Props = {
  data: any
}

export default function RelatedPostList(props: Props){
  const { id } = props.data.mdx;
  const { category } = props.data.mdx.frontmatter;
  const data = useStaticQuery(
    graphql`
      query {
        allMdx(
          limit: 1000,
          sort: { order: DESC, fields: frontmatter___date }, 
          filter: { 
            frontmatter: { 
              publish: { eq: true }
              posttype: { ne: "issue" }
            } 
          }
        ) {
          nodes {
            id
            frontmatter {
              date
              title
              slug
              category
              posttype
              icon {
                childImageSharp {
                  gatsbyImageData
                }
              }
              tags
            }
            parent {
              ... on File {
                name
              }
            }
          }
        }
      }
    `
  )
  const relatedPosts = data.allMdx.nodes
    .filter(post => 
      category && 
      category === post.frontmatter.category && 
      id !== post.id
    )
    .filter((post,index) => index < 5) 
    .map(post => post);
  console.log(data);
  const Wrapper = styled.div`
    h4{
      font-size:12px;
      font-weight:bold; 
      background-color:#333; 
      text-align:center; 
      color:white; 
      padding:10px 0;
    }
    .no-post{
      font-size:12px;
      text-align: center;
    }
  `;
  return (
    <Wrapper>
      <div className="related-posts mt-4 mb-4">
        <h4>関連記事</h4>
        {relatedPosts.map(post => (
          <RelatedPostItem data={post}/>
        ))}
        {relatedPosts.length === 0 && (
          <div className="no-post">関連記事はありません</div>
        )}
      </div>
    </Wrapper>
  );
}